import { SubUser } from "../types";
import { api } from "./base.api";

export const subUsersAPI = {
  createSubUser: async (subUser: Partial<SubUser>) => {
    delete subUser.user;
    delete subUser.userId;
    const response = await api.post("/subusers", subUser);
    return response.data;
  },

  getSubUsers: async (page: number = 1, limit: number = 5) => {
    const response = await api.get<{
      subUsers: SubUser[];
      pagination: {
        total: number;
        page: number;
        limit: number;
        pages: number;
      };
    }>(`/subusers?page=${page}&limit=${limit}`);
    return response.data;
  },

  getSubUser: async (id: string) => {
    const response = await api.get<SubUser>(`/subusers/${id}`);
    return response.data;
  },

  updateSubUser: async (id: string, subUser: Partial<SubUser>) => {
    console.log({ subUser });
    const response = await api.patch<SubUser>(`/subusers/${id}`, subUser);
    return response.data;
  },

  deleteSubUser: async (id: string) => {
    const response = await api.delete(`/subusers/${id}`);
    return response.data;
  },
};
